import { render, staticRenderFns } from "./EditAdmProfileForm.vue?vue&type=template&id=459e10e0"
import script from "./EditAdmProfileForm.vue?vue&type=script&lang=js"
export * from "./EditAdmProfileForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports